import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgSettings({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.312 21.866a7.405 7.405 0 0 0-1.848-.233c-.639 0-1.258.08-1.849.233V6.848a1.848 1.848 0 0 1 3.697 0v15.018Zm0 2.21v9.897a5.269 5.269 0 0 1-1.847.332c-.651 0-1.274-.118-1.85-.333v-9.895a5.268 5.268 0 0 1 1.85-.332c.65 0 1.272.117 1.846.332Zm-3.697 12.108c.591.152 1.21.233 1.849.233a7.4 7.4 0 0 0 1.848-.233v3.93a1.848 1.848 0 0 1-3.697 0v-3.93Z"
            />
            <circle
                cx={33.464}
                cy={29.025}
                r={5.28}
                transform="rotate(90 33.464 29.025)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.412 25.096a7.409 7.409 0 0 1-3.696 0v15.017a1.848 1.848 0 0 0 3.696 0V25.096Zm0-2.212V12.99a5.27 5.27 0 0 0-1.848-.333 5.27 5.27 0 0 0-1.848.333v9.895a5.27 5.27 0 0 0 1.848.333c.65 0 1.273-.118 1.848-.333Zm-3.696-12.107a7.404 7.404 0 0 1 1.848-.233c.638 0 1.257.081 1.848.233V6.848a1.848 1.848 0 1 0-3.696 0v3.93Z"
            />
            <circle r={5.28} transform="matrix(0 -1 -1 0 16.564 17.936)" />
        </svg>
    )
}
SvgSettings.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgSettings
